import Joi from "joi";


const NameValidation = (name) => {
    return Joi.string()
        .min(3)
        .max(35)
        .pattern(/^(?!\s*$)[A-Za-z\s]+$/) // Allows only letters and spaces, and not spaces only
        .required()
        .messages({
            "string.min": `${name} must be at least three characters`,
            "string.max": `${name} exceeds the maximum length of 35 characters`,
            "string.pattern.base":
                `${name} cannot contain special characters or numeric values`,
            "any.required": `${name} is required`,
            "string.empty": `${name} is required`,
        });
}
const NameAndNumberValidation = (name) => {
    return Joi.string()
        .min(3)
        .max(35)
        .required()
        .messages({
            "string.min": `${name} must be at least three characters`,
            "string.max": `${name} exceeds the maximum length of 35 characters`,
            "any.required": `${name} is required`,
            "string.empty": `${name} is required`,
        });
}
const EmailValidation = Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
        "string.email": "Invalid Email",
        "any.required": "Email is required",
        "string.empty": "Email is required",
    });
const IBDValidation = Joi.string()
    .pattern(/^[A-Za-z0-9-]+$/) // Allows alphanumeric characters and dashes
    .allow("")
    .messages({
        "string.pattern.base": "Invalid IBD number format",
    });


const WithoutValidation = Joi.any();

    const DropDownValidation = (option, isArray = true) => {
        return isArray
            ? Joi.array()
                .length(1) // Ensures exactly one element in the array
                .items(Joi.string().invalid(`Select ${option}`)) // Validate the single element
                .required()
                .messages({
                    "array.length": `Only one ${option} must be selected`,
                    "any.invalid": `${option} is required`,
                })
            : Joi.string()
                .invalid(`Select ${option}`) // Prevent default invalid option
                .required()
                .messages({
                    "string.empty": `${option} is required`,
                    "any.invalid": `${option} is required`,
                });
    };
    const PONumberValidation = (option) => {
        let schema = Joi.alternatives()
            .try(Joi.allow(null))
            .invalid("", `Select ${option}`);

        schema = schema.try(
            Joi.string()
                .pattern(/^[A-Za-z0-9-]+$/)
                .min(5)
                .max(20)
        );

        return schema.required().messages({
            "string.pattern.base": `${option} must be alphanumeric and can include hyphens`,
            "string.min": `${option} must be at least 5 characters`,
            "string.max": `${option} must be at most 20 characters`,
            "any.only": `${option} is required`,
            "any.invalid": `${option} is required`,
        });
    };







const OptionalDropDownValidation = (option, optionsList = []) => {
    let schema = Joi.alternatives()
        .try(Joi.allow(null)) // Allow null as a valid option
        .invalid("",`Select ${option}`); // Reject empty string

    if (optionsList.length > 0) {
        schema = schema.try(Joi.valid(...optionsList)); // Validate only if options exist
    }

    return schema
        .required()
        .messages({
            "any.only": `${option} is required`,
            "any.invalid": `${option} is required`,
        });
};
// Validates that the date must be now or in the past (i.e. not a future date)
const pastOrNowDateValidation = Joi.date()
    .max('now')
    .required()
    .messages({
        "date.max": "Date must be today or in the past",
        "any.required": "Date is required",
        "date.base": "Date is required"
    });

// Validates that the date must be now or in the future (i.e. not a past date)
const NowOrLaterDateValidation = Joi.date()
    .min('now')
    .required()
    .messages({
        "date.min": "Date must be today or in the future",
        "any.required": "Date is required",
        "date.base": "Invalid date format"
    });

const ChangePasswordSchema = (matched) => Joi.object({
    currentPassword: Joi.string()
        .required()
        .allow("")
        .messages({
            "any.required": "Current Password is required",
            "string.empty": "Current Password is required",
        }),

    newPassword: matched ? Joi.string()
        .min(8)
        .invalid(Joi.ref('currentPassword'))
        .required()
        .messages({
            "string.min": "New Password must be at least 8 characters",
            "any.invalid": "New Password must be different from Current Password",
            "any.required": "New Password is required",
            "string.empty": "New Password is required",
        }) : Joi.string().allow(""),  // No validation when matched is false

    confirmNewPassword: matched ? Joi.string()
        .valid(Joi.ref('newPassword'))
        .required()
        .messages({
            "any.only": "New Password Confirmation must match New Password",
            "any.required": "New Password Confirmation is required",
            "string.empty": "New Password Confirmation is required",
        }) : Joi.string().allow(""),  // No validation when matched is false
});


export { NameValidation, EmailValidation, OptionalDropDownValidation, DropDownValidation, ChangePasswordSchema ,PONumberValidation, WithoutValidation,pastOrNowDateValidation,NowOrLaterDateValidation,IBDValidation, NameAndNumberValidation};

